// In the transition from jade to pug, the pug loader now puts the template
// function for templates/foo.jst.pug at JST['templates/foo.jst'], where it used
// to be at JST['templates/foo']. However, we also explicitly set many templates
// in auxiliary foo_JST.wjs.js files, which put the templates at
// JST['templates/foo'].
//
// Instead of trying to fix all of the places that reference these templates to
// use the correct name, this just adds a compatibility layer where a lookup for
// JST['templates/foo'] will also check JST['templates/foo.jst'].
if (!window.JST || !window.JST.__special) {
  window.JST = window.JST || {};
  window.JST = new Proxy(window.JST, {
    get: function (target, property) {
      if (property === '__special') {
        return true;
      } else if (typeof property === 'string' && `${property}.jst` in target) {
        // If attempting to fetch JST['foo'] but JST['foo.jst'] exists, return
        // JST['foo.jst'] instead
        return target[`${property}.jst`];
      } else {
        return target[property];
      }
    },
  });
}
